export default class QuizProgressBar {
    constructor() {
        this.progressBar = document.querySelector('.quiz-progress-bar');
        this.quiz = document.querySelector('.wpProQuiz_quiz');
        
        if (this.progressBar && this.quiz) {
            this.total = this.quiz.querySelectorAll('.wpProQuiz_listItem').length;
            this.answeredQuestions = new Set();
            this.init();
        }
    }

    init() {
        this.initElements();
        this.addEventListeners();
        this.updateProgress();
    }

    initElements() {
        this.progress = this.progressBar.querySelector('.progress');
        this.countElement = this.progressBar.querySelector('.questions-count');
    }

    addEventListeners() {
        // For single/multiple choice questions
        this.quiz.addEventListener('change', (e) => {
            if (e.target.matches('input[type="radio"], input[type="checkbox"]')) {
                this.handleAnswer(e.target);
            }
        });

        // For matrix sort questions
        this.quiz.addEventListener('mouseup', (e) => {
            const sortItem = e.target.closest('.wpProQuiz_sortStringItem');
            if (sortItem) {
                const question = e.target.closest('.wpProQuiz_listItem');
                if (question && question.getAttribute('data-type') === 'matrix_sort_answer') {
                    this.handleAnswer(question);
                }
            }
        });

        // For regular sorting questions
        this.quiz.addEventListener('mouseup', (e) => {
            const questionList = e.target.closest('.wpProQuiz_questionList[data-type="sort_answer"]');
            if (questionList) {
                const questionItem = e.target.closest('.wpProQuiz_questionListItem');
                if (questionItem) {
                    const mainQuestion = questionList.closest('.wpProQuiz_listItem');
                    if (mainQuestion) {
                        this.handleAnswer(mainQuestion);
                    }
                }
            }
        });

        // For fill in blank
        this.quiz.addEventListener('input', (e) => {
            if (e.target.matches('.wpProQuiz_cloze input')) {
                const question = e.target.closest('.wpProQuiz_listItem');
                if (question && e.target.value.trim()) {
                    this.handleAnswer(e.target);
                }
            }
        });

        // For essay questions
        this.quiz.addEventListener('input', (e) => {
            if (e.target.matches('textarea.wpProQuiz_questionEssay')) {
                const question = e.target.closest('.wpProQuiz_listItem');
                if (question && e.target.value.trim()) {
                    this.handleAnswer(e.target);
                }
            }
        });

        // Reset progress when quiz starts
        document.addEventListener('learndash_quiz_started', () => {
            this.answeredQuestions.clear();
            this.updateProgress();
        });

        // Mark all questions as answered when quiz completes
        document.addEventListener('learndash_quiz_completed', () => {
            for (let i = 0; i < this.total; i++) {
                this.answeredQuestions.add(i);
            }
            this.updateProgress();
        });
    }

    handleAnswer(element) {
        const question = element.closest('.wpProQuiz_listItem');
        if (!question) return;

        const index = Array.from(this.quiz.querySelectorAll('.wpProQuiz_listItem')).indexOf(question);
        if (index !== -1) {
            this.answeredQuestions.add(index);
            this.updateProgress();
        }
    }

    updateProgress() {
        if (!this.progress || !this.countElement) return;

        const answered = this.answeredQuestions.size;
        const percentage = (answered / this.total) * 100;

        this.progress.style.width = `${percentage}%`;
        const label = answered > 1 ? $('.quiz-progress-bar .questions-count').attr('data-questions') : $('.quiz-progress-bar .questions-count').attr('data-question');
        this.countElement.textContent = `${label} ${answered}/${this.total}`;
    }
}
